import React from 'react';
import propTypes from 'prop-types';

import style from './index.less';

const MessageBox = ({ children, status = 'msg-wrapper-agent' }) => {
  return (
    <div className={`${style['msg-wrapper']} ${style[status]}`}>
      <div>{children}</div>
    </div>
  );
};

MessageBox.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.element), propTypes.element]),
  /** 状态分类：msg-wrapper-agent、msg-wrapper-client、msg-wrapper-internal、msg-wrapper-anonymous */
  status: propTypes.string
};

export default MessageBox;
